import { FC, memo } from 'react'

import { GuestPickerIcon, NonSelectableWidgetInputContainer, WidgetContainer } from '../widget-styles'
import { useTranslation } from '../../../../../hooks/locale'
import { GuestsInput, GuestPickerWidgetCard, PetsEditWrapper, PetsEditLabel } from './widget-styles'
import { EditIcon } from '../../../../common/icons'
import { getGuestPickerLabel } from '../utils'
import { GuestPickerWidgetProps } from '../../../../common/guest-picker/types'
import { InputError } from '../../../../common/input-styles'

const GuestPickerWidget: FC<GuestPickerWidgetProps> = ({
    isOpen,
    onOpen,
    adultsCount,
    childrenCount,
    petsCount,
    error,
    inputRef,
    children,
    petsAllowed,
    isRounded,
    border,
    widgetHeight,
    showEditIcon,
}) => {
    const { t } = useTranslation()

    const _totalGuestsCount = adultsCount + childrenCount
    const _guestLabel = getGuestPickerLabel(_totalGuestsCount, t('guest'), t('guests'), t('addGuests'))
    const _guestPickerLabel = _guestLabel
    const _petsLabel = petsAllowed
        ? (petsCount ?? 0) > 0
            ? `${petsCount} ${t('petsGuest')}`
            : `${t('petsGuest')}?`
        : null

    return (
        <WidgetContainer ref={inputRef as any}>
            <NonSelectableWidgetInputContainer
                hasError={!!error}
                isRounded={isRounded}
                border={border}
                widgetHeight={widgetHeight}
            >
                <GuestPickerIcon aria-label={t('guestIconText')} />
                <GuestsInput value={_guestPickerLabel} onClick={onOpen} />
                {showEditIcon && petsAllowed && (
                    <PetsEditWrapper onClick={onOpen}>
                        <PetsEditLabel>{_petsLabel}</PetsEditLabel>
                        <EditIcon />
                    </PetsEditWrapper>
                )}
                {!!error && <InputError alignRight>{error}</InputError>}
            </NonSelectableWidgetInputContainer>

            <GuestPickerWidgetCard isOpen={isOpen}>{children}</GuestPickerWidgetCard>
        </WidgetContainer>
    )
}

export default memo(GuestPickerWidget)
